module.exports = __webpack_public_path__ + "static/media/dog10.2f796f9e.jpeg";